import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { bodyBusquedaFactura, BodyEmail, ConfigAutoportal, EmailEnviado, FacturaConsultada } from '../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutoportalService {
  readonly header: HttpHeaders;
  constructor(
    private http: HttpClient
  ) {
    this.header = new HttpHeaders({
      "Content-Type": "application/json",
      "Api-Key": environment.apk
    });
  }

  public enviarEmail(body: BodyEmail): Observable<EmailEnviado> {
    return this.http.post<EmailEnviado>(`${environment.api_autoportal}/api/v2/autofacturador/facturacion/email`, JSON.stringify(body), { headers: this.header });
  }

  public getConfigAutoportal(configuration: string): Observable<ConfigAutoportal> {
    return this.http.get<ConfigAutoportal>(`${environment.api_configuracion}/configuration/${configuration}`);
  }

  public getFacturaConsulta(body: bodyBusquedaFactura) : Observable<FacturaConsultada> {
    return this.http.post<FacturaConsultada>(`${environment.api_autoportal}/api/v2/autofacturador/facturacion/factura`, JSON.stringify(body), { headers: this.header });
  }
}
